import React from 'react';
import Parser from 'html-react-parser';

function Libre({title, description, index, background, align = 'center',justify = 'center', type="default"}) {
    const bgStyle = background ? { background } : {};


    function getTitleClass(type){
        switch (type){
            case 'home':
                return 'libre-title-home';
            case 'formation':
                return 'libre-title-formation petit';
            default:
                return `libre-title`;
        }
    }

    function getTextClass(type){
        switch (type){
            case 'home':
                return 'libre-text-home';
            case 'formation':
                return 'libre-text-formation';
            default:
                return `libre-text`;
        }
    }

    return (
            <section className="libre layout-pt-40 layout-pb-40" style={bgStyle}  key={index}>
                <div className="auto-container">
                    <div className={`d-flex flex-column col-12 gap-4 align-items-${align} justify-content-${justify}`}>
                        {title ? (
                        <h2 className={getTitleClass(type)}>
                            {Parser(title)}
                        </h2>
                        ) : null}
                        {description ? (
                        <div className={getTextClass(type)}>
                            {Parser(description)}
                        </div>
                        ) : null}
                    </div>
                </div>
            </section>
        );
}

export default Libre;
